import { truncate } from 'lodash';

// Should be > MAX_TITLE_IN_FORMAT_LEN in `errorbox/extract.py`
// https://github.com/zapier/zapier/blob/develop/web/backend/zapier/app_platform/errorbox/extract.py#L41
// plus about 50 for the text is adds arround in `_format_title_of_response`
const MAX_MESSAGE_LENGTH = 200 + 50;

// split first and remaining lines of an error and do some magic
// follow same logic as useful.error_tools.construct_full_error_message()
const parseErrorMessage = (errorMessage = '') => {
  // match to find message and details
  const errorMessageLines = errorMessage.trim().match(/.+[\n\r]*/g) || [];

  let title = (errorMessageLines[0] || '').trim();
  let details;
  if (title.length > MAX_MESSAGE_LENGTH) {
    details = errorMessage;
    title = truncate(title, {
      length: MAX_MESSAGE_LENGTH,
    });
  } else {
    details = errorMessageLines.slice(1).join('');
  }

  details = details
    .replace(/\r/g, '') // drop windows-style linebreaks
    .replace(/^[ \t]+$/gm, '') // drop empty lines
    .replace(/[\n]{2,}/g, '\n\n') // limit to 2 linebreaks
    .replace(/[ \t]+$/gm, '') // drop whitespace at end of lines or full lines of
    .replace(/^\n+|( *\n+)$/, ''); // get rid of linebreaks at start and end

  if (title === details) {
    details = '';
  }

  return {
    title,
    details,
  };
};

export default parseErrorMessage;
